import React, { createContext, useContext } from "react";
import { Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "@emotion/css";

// Crear el contexto para el toast
const ToastContext = createContext();

// Hook personalizado para usar el contexto
export const useToast = () => useContext(ToastContext);

// Proveedor del contexto
export const ToastProvider = ({ children }) => {
	// Función para mostrar el mensaje
	const showMessage = ({ message, type = "success" }) => {
		if (type === "success") {
			toast.success(message, {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",
				transition: Slide,
				style: {
					backgroundColor: "#1dd1a1", // Aquí estableces el color de fondo
					color: "#ffffff", // También puedes cambiar el color del texto si lo necesitas
				},
			});
		} else if (type === "danger") {
			toast.error(message, {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",
				transition: Slide,
				style: {
					backgroundColor: "#eb4d4b", // Aquí estableces el color de fondo
					color: "#ffffff", // También puedes cambiar el color del texto si lo necesitas
				},
			});
		} else if (type === "info") {
			toast.info(message, {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",
				transition: Slide,
				style: {
					backgroundColor: "#7ed6df", // Aquí estableces el color de fondo
					color: "#ffffff", // También puedes cambiar el color del texto si lo necesitas
				},
			});
		} else if (type === "warning") {
			toast.warning(message, {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",
				transition: Slide,
				style: {
					backgroundColor: "#f9ca24", // Aquí estableces el color de fondo
					color: "#ffffff", // También puedes cambiar el color del texto si lo necesitas
				},
			});
		} else if (type === "error") {
			toast.error(message, {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",
				transition: Slide,
				style: {
					backgroundColor: "#eb4d4b", // Aquí estableces el color de fondo
					color: "#ffffff", // También puedes cambiar el color del texto si lo necesitas
				},
			});
		}
	};

	return (
		<ToastContext.Provider value={{ showMessage }}>
			{children}

			<ToastContainer
				toastClassName={css({ fontFamily: "Montserrat", fontSize: "14px" })}
			/>
		</ToastContext.Provider>
	);
};
